//#region imports

// react
import React, { useEffect, useMemo, useState } from 'react';
import Select from "react-select";

// react bootstrap
import { Form } from 'react-bootstrap';

// styling
import { Colors, Spacing } from "_styles";

// icons
import { BsLayoutSidebarReverse } from "react-icons/bs";
import { IoSearch } from "react-icons/io5";
import { FaSearch } from "react-icons/fa";

// custom components
import { CustomSpinner } from '_atoms';

// tremor
import { Toggle, ToggleItem } from '@tremor/react';

// redux
import { useDispatch, useSelector } from "react-redux";
import { selectGetLocationsDataStatus } from '_redux/slices/timeline/timeline-dashboard';
import { selectAllTimelineAreas } from '_redux/slices/timeline/timeline-areas';
import { selectUsedTheme } from '_redux/slices/timeline/theme';
import { selectLocationsTableView, setLocationsTableView } from '_redux/slices/timeline/timeline-control';

//#endregion

const AirportLocationsHeader = (props) => {

    const dispatch = useDispatch();
    const usedTheme = useSelector(selectUsedTheme);
    const locationsTableView = useSelector(selectLocationsTableView);

    return (
        <div className='d-flex flex-column gap-2'>

            <div style={{ display: 'flex', alignItems: 'center', gap: Spacing.SCALE_8 }}>
                {/* search pax locations */}
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    flex: 1,
                    backgroundColor: usedTheme.BACKGROUND_COLOR,
                    border: `1px solid ${usedTheme.BORDER_COLOR}`,
                    borderRadius: '6px',
                    padding: '6px 12px',
                }}>
                    <FaSearch
                        color={usedTheme.TEXT_COLOR}
                        size={14}
                        style={{ opacity: 0.5, marginRight: Spacing.SCALE_8, flexShrink: 0 }}
                    />
                    <input
                        type="text"
                        placeholder="Filter by Location Title"
                        onChange={(e) => { props?.setSearchTerm(e.target.value) }}
                        style={{
                            border: 'none',
                            outline: 'none',
                            backgroundColor: 'transparent',
                            color: usedTheme.TEXT_COLOR,
                            fontSize: '14px',
                            width: '100%',
                        }}
                    />
                </div>

                {/* view switcher */}
                <Toggle
                    color="zinc"
                    defaultValue="cards"
                    value={locationsTableView ? "detail" : "cards"}
                    onValueChange={(value) => dispatch(setLocationsTableView(value === "detail"))}
                >
                    <ToggleItem value="cards" text="Cards" />
                    <ToggleItem value="detail" text="Table" />
                </Toggle>
            </div>
        </div>
    );
};

export default AirportLocationsHeader;
